export default {
  methods: {
    /**
     * Check if the current user can delete a feature request
     * User can delete if:
     * 1. They are the owner of the request
     * 2. They have admin, lead, or developer role
     * @param {Object} request - Feature request object with owner property
     * @returns {Boolean}
     */
    canDeleteFeatureRequest(request) {
      if (!request) return false;

      // Get current user from localStorage
      const userStr = localStorage.getItem("user");
      if (!userStr) return false;

      const user = JSON.parse(userStr);
      const userEmail = user.email || "";
      const userRole = (user.role || "").toLowerCase();

      // Check if user is the owner
      if (request.owner === userEmail) {
        return true;
      }

      // Check if user has privileged role
      const privilegedRoles = [/admin/, /lead/, /developer/];
      const hasPrivilegedRole = privilegedRoles.some((rx) => rx.test(userRole));

      return hasPrivilegedRole;
    },

    /**
     * Get current user email
     * @returns {String}
     */
    getCurrentUserEmail() {
      const userStr = localStorage.getItem("user");
      if (!userStr) return "";

      const user = JSON.parse(userStr);
      return user.email || "";
    },
  },
};
